export default "__VITE_ASSET__CSP7slut__"